export default "__VITE_PUBLIC_ASSET__8f846b45__"